/**
 * MEU ERP API - Equipment Category Service (CHỦNG thiết bị)
 * Endpoints: /api/equipmentTypes/equipmentCategories
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
} from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';

import { Observable } from 'rxjs';

import { BASE_PATH } from '../variables';
import { Configuration } from '../configuration';

@Injectable()
export class EquipmentCategoryService {
  protected basePath = '/';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string,
    @Optional() configuration: Configuration
  ) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  private canConsumeForm(consumes: string[]): boolean {
    return consumes.indexOf('multipart/form-data') !== -1;
  }

  private jsonHeaders(): HttpHeaders {
    let headers = this.defaultHeaders;
    const consumes: string[] = [
      'application/json-patch+json',
      'application/json',
      'text/json',
      'application/_*+json',
    ];
    const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }
    return headers;
  }

  /**
   * GET danh sách CHỦNG thiết bị (Equipment Categories)
   */
  public apiEquipmentCategoriesGet(
    filters?: string,
    sorts?: string,
    page?: number,
    pageSize?: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let queryParameters = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec(),
    });
    if (filters !== undefined && filters !== null) {
      queryParameters = queryParameters.set('Filters', <any>filters);
    }
    if (sorts !== undefined && sorts !== null) {
      queryParameters = queryParameters.set('Sorts', <any>sorts);
    }
    if (page !== undefined && page !== null) {
      queryParameters = queryParameters.set('Page', <any>page);
    }
    if (pageSize !== undefined && pageSize !== null) {
      queryParameters = queryParameters.set('PageSize', <any>pageSize);
    }

    return this.httpClient.request<any>(
      'get',
      `${this.basePath}/api/equipmentTypes/equipmentCategories`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: this.defaultHeaders,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * GET chi tiết CHỦNG thiết bị
   */
  public apiEquipmentCategoriesIdGet(
    id: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling apiEquipmentCategoriesIdGet.');
    }
    return this.httpClient.request<any>(
      'get',
      `${this.basePath}/api/equipmentTypes/equipmentCategories/${encodeURIComponent(String(id))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: this.defaultHeaders,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * POST tạo CHỦNG thiết bị
   */
  public apiEquipmentCategoriesPost(
    body?: any,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    return this.httpClient.request<any>(
      'post',
      `${this.basePath}/api/equipmentTypes/equipmentCategories`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: this.jsonHeaders(),
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * PUT cập nhật CHỦNG thiết bị
   */
  public apiEquipmentCategoriesIdPut(
    id: string,
    body?: any,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling apiEquipmentCategoriesIdPut.');
    }
    return this.httpClient.request<any>(
      'put',
      `${this.basePath}/api/equipmentTypes/equipmentCategories/${encodeURIComponent(String(id))}`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: this.jsonHeaders(),
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * DELETE xóa CHỦNG thiết bị
   */
  public apiEquipmentCategoriesIdDelete(
    id: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling apiEquipmentCategoriesIdDelete.');
    }
    return this.httpClient.request<any>(
      'delete',
      `${this.basePath}/api/equipmentTypes/equipmentCategories/${encodeURIComponent(String(id))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: this.defaultHeaders,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * PUT upload icon/image cho CHỦNG thiết bị
   */
  public apiEquipmentCategoriesIdImagePut(
    id: string,
    file?: Blob,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling apiEquipmentCategoriesIdImagePut.');
    }

    const consumes: string[] = ['multipart/form-data'];
    const canConsumeForm = this.canConsumeForm(consumes);
    let formParams: { append(param: string, value: any): void };
    if (canConsumeForm) {
      formParams = new FormData();
    } else {
      formParams = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
    }
    if (file !== undefined) {
      formParams = (formParams.append('file', <any>file) as any) || formParams;
    }

    return this.httpClient.request<any>(
      'put',
      `${this.basePath}/api/equipmentTypes/equipmentCategories/${encodeURIComponent(String(id))}/image`,
      {
        body: formParams,
        withCredentials: this.configuration.withCredentials,
        headers: this.defaultHeaders,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }
}
